import React from 'react';
import './Education.css'

const Education = () => {
    return (
        <div data-aos="flip-left" data-aos-duration="1000">
            <ul>
                <li><span>2022</span><br />BA</li>
                <li><span>2019</span><br />HSC</li>
                <li><span>2017</span><br />SSC</li>
            </ul>
        </div>
    );
};

export default Education;